import Detail from '../../../../components/Detail';
import { formatUSD } from '../../../../helpers/formats';
import useUserStakedSpool from '../../../../hooks/web3/vault/useUserStakedSpool';

const StakedSpool: React.FC = () => {
    const { userStakedSpool } = useUserStakedSpool();

    return (
        <Detail
            title='Your SPOOL Staked'
            value={`${formatUSD(userStakedSpool || 0)} $SPOOL`}
        />
    );
};

export default StakedSpool;
